import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
// CORRECCIÓN AQUÍ: Subimos 3 niveles (../../../) para llegar a 'src'
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroProducto({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS ---
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");
  const [nombre, setNombre] = useState(initialFilters.nombre || "");
  const [codigoSap, setCodigoSap] = useState(initialFilters.codigoSap || "");
  const [estadoId, setEstadoId] = useState(initialFilters.estadoId || "");
  const [ivaId, setIvaId] = useState(initialFilters.ivaId || "");
  const [rubroId, setRubroId] = useState(initialFilters.rubroId || "");

  const [listas, setListas] = useState({
    ivas: [],
    rubros: [],
    estados: [],
  });

  const [isLoading, setIsLoading] = useState(false);

  // --- CARGA DE CATÁLOGOS ---
  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const [resIva, resRub, resEst] = await Promise.all([
          appFetchJson(apiRoutes.ivas.listUrl({ page: 0, size: 200 })),
          appFetchJson(apiRoutes.rubros.listUrl({ page: 0, size: 200 })),
          appFetchJson(apiRoutes.estado.listUrl({ page: 0, size: 200 })),
        ]);
        setListas({
          ivas: resIva?.items || [],
          rubros: resRub?.items || [],
          estados: (resEst?.items || []).filter((e) => e.tipoId === 3),
        });
      } catch (e) {
        console.error("Error cargando filtros:", e);
      }
    };
    cargarCatalogos();
  }, []);

  // --- SUBMIT ---
  const handleApply = async () => {
    setIsLoading(true);
    // Simulación opcional
    // await new Promise(r => setTimeout(r, 300));

    onSubmit({
      codigo: codigo.trim(),
      nombre: nombre.trim(),
      codigoSap: codigoSap.trim(),
      estadoId: estadoId || null,
      ivaId: ivaId || null,
      rubroId: rubroId || null,
    });
    
    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Productos"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. COD. PRODUCTO */}
      <div>
        <label className="form-label-fil">Cód. Producto:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
        />
      </div>

      {/* 2. DESCRIPCIÓN */}
      <div>
        <label className="form-label-fil">Descripción:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />
      </div>

      {/* 3. COD. SAP */}
      <div>
        <label className="form-label-fil">Cod. SAP:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={codigoSap}
          onChange={(e) => setCodigoSap(e.target.value)}
        />
      </div>

      {/* 4. ESTADO */}
      <div>
        <label className="form-label-fil">Estado:</label>
        <select
          className="input mt-1 w-full"
          value={estadoId}
          onChange={(e) => setEstadoId(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {listas.estados.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* 5. IVA */}
      <div>
        <label className="form-label-fil">Iva:</label>
        <select
          className="input mt-1 w-full"
          value={ivaId}
          onChange={(e) => setIvaId(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {listas.ivas.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* 6. RUBRO */}
      <div>
        <label className="form-label-fil">Rubro:</label>
        <select
          className="input mt-1 w-full"
          value={rubroId}
          onChange={(e) => setRubroId(e.target.value)}
        >
          <option value="">-- Seleccione --</option>
          {listas.rubros.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.nombre}
            </option>
          ))}
        </select>
      </div>
      
    </DrawerFilter>
  );
}